import { render, staticRenderFns } from "./control-cifras-oeb.vue?vue&type=template&id=61aa0a56&scoped=true"
import script from "./control-cifras-oeb.vue?vue&type=script&lang=js"
export * from "./control-cifras-oeb.vue?vue&type=script&lang=js"
import style0 from "./control-cifras-oeb.vue?vue&type=style&index=0&id=61aa0a56&prod&scoped=true&lang=css"
import style1 from "./control-cifras-oeb.vue?vue&type=style&index=1&id=61aa0a56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aa0a56",
  null
  
)

export default component.exports